module.exports = __webpack_public_path__ + "static/media/study 210519.e13b8aca.png";